module.exports = "/images/Brand my company better.svg?016d83246a4f975075a81f359d7c216b";